export enum RESOURCE_MEDIA_TYPE {
    /**
     * 视频
     */
    TYPE_VIDEO = 1,
    /**
     * 文档
     */
    TYPE_DOCUMENT = 2,
    /**
     * 直播流
     */
    TYPE_LIVE = 3,
    /**
     * 图文微课资源
     */
    TYPE_IMG_TEXT = 4,
    /**
     * 语音微课
     */
    TYPE_AUDIO_WEIKE = 5,
    /**
     * 封面图
     */
    TYPE_COVER_IMG = 6,
    /**
     * 富文本资源（小节的富文本说明信息）
     */
    TYPE_MULTIMEDIA_TEXT = 7,
    /**
     * 作业要求图片
     */
    TYPE_ELEMENT_IMAGE = 8,
    /**
     * 语音微课转视频
     */
    TYPE_WEIKE2VIDEO = 9,
    /**
     * 作业范例
     */
    TYPE_HOMEWORK_EXAMPLE = 10,
    /**
     * 作业多维度评价图片
     */
    TYPE_HOMEWORK_MULTI_EVAL_IMAGE = 11,
    /**
     * 会议
     */
    TYPE_MEETTING = 12,
    /**
     * ai微课
     */
    TYPE_AI_AUDIO_SLIDES = 16
}

/* element类型的枚举 */
export enum ELEMENT_TYPE {
    /**
     * 问卷
     */
    Survey = 1,
    /**
     * 提问
     */
    Ask = 2,
    /**
     * 讨论
     */
    Discussion = 3,
    /**
     * 拍照
     */
    Photo = 4,
    /**
     * 游戏
     */
    Game = 5,
    /**
     * 签到
     */
    Attendance = 6,
    /**
     * 微课
     */
    MiniCourse = 7,
    /**
     * 抽奖
     */
    RaffleDrawing = 8,
    /**
     * 报名
     */
    Registration = 9,
    /**
     * 考试
     */
    Quiz = 10,
    /**
     * 视频
     */
    Video = 11,
    /**
     * 直播
     */
    Live = 12,
    /**
     * 文章
     */
    Article = 13,
    /**
     * 文档
     */
    Documents = 14,
    /**
     * 图文
     */
    ImageArticle = 15,
    /**
     * 作业
     */
    Homework = 16,
    /**
     * 会议
     */
    Meeting = 17,
    /**
     * 直播new
     */
    Live_Pro = 18,
    /**
     * AI 微课
     */
    AiAudioSlides = 19,
    /**
     * 阶段点评
     */
    StageReviews = 20
}

export enum KEY_CODE {
    KEY_BACKSPACE = 8,
    KEY_ENTER = 13,
    KEY_ESCAPE = 27,
    KEY_ARROW_LEFT = 37,
    KEY_ARROW_UP = 38,
    KEY_ARROW_RIGHT = 39,
    KEY_ARROW_DOWN = 40,
    KEY_DELETE = 46,
    KEY_0 = 48,
    KEY_1 = 49,
    KEY_2 = 50,
    KEY_3 = 51,
    KEY_4 = 52,
    KEY_5 = 53,
    KEY_6 = 54,
    KEY_7 = 55,
    KEY_8 = 56,
    KEY_9 = 57
}

export enum PRODUCT_TYPE {
    /**
     * 商业化购买-默认 -> 0
     */
    COMMERCIALIZE = 0,

    /**
     * 学习圈报名learning-circle -> 1
     */
    LEARNING_CIRCLE = 1,

    /**
     * umu点数购买 -> 2
     */
    UMU_BLANCE = 2
}

/**
 * 支付渠道
 */
export enum PAYMENT_MODE {
    ALIPAY = '1',
    PAYPAL = '2',
    WXPAY = '3'
}

/**
 * 支付结果状态
 */
export enum PAYMENT_RESULT_STATUS {
    /**
     * 待支付
     */
    PENDING = '0',
    /**
     * 支付中
     */
    PAYING = '1',
    /**
     * 支付成功
     */
    PAY_SUCCESS = '2',
    /**
     * 支付失败
     */
    PAY_FAIL = '3',
    /**
     * 关闭
     */
    PAY_CLOSE = '4'
}

/**
 * 支付客户端类型
 */
export enum PAYMENT_CLIENT_MODE {
    /**
     * pc端支付
     */
    PC = '0',
    /**
     * 移动页面端支付
     */
    WAP = '1'
}

/**
 * 支付渠道类型
 */
export enum PAYMENT_TYPE {
    ALIPAY = 'alipay',
    WXPAY = 'wxpay',
    PAYPAL = 'paypal'
}

export enum PAYMENT_TYPE_MODE {
    alipay = 1,
    paypal = 2,
    wxpay = 3
}

/**
 * 微信支付方式的渠道
 */
export enum PAYMENT_MODE_CHANNEL {
    /**
     * 微信二维码支付(默认)
     */
    WX_PUB_QR = 'wx_pub_qr',
    /**
     * 微信内支付
     */
    WX_PUB = 'wx_pub'
}

/**
 * 用户所在的plan info
 * teacher_status 账户类型逻辑判断
 * 0.新用户
 * 1.基本版一C端免费注册账户，不显示到期时间
 * 2.高级版-付费高级版，显示到期时间，过期后变为基本版
 * 3.未验证邮件
 * 4.VIP高级版(非付费) -非付费升级高级版，显示到期时间，过期后变为基本版
 * 5.教育版基本版一教育版高级版”到期后，展示为“教育版基本版”，
 * 6.教育版高级版一教育版升级用户，显示到期时间，过期后显示为“教育版基本版”
 * 7. 企业版
 * 8.企业版试用版
 * 9.商用版
 * 10.商用版试用
 */
export enum PLAN_TYPE {
    /**
     * 1. 基本版
     */
    BASIC = 1,

    /**
     * 2. 专业版
     */
    PROFESSIONAL = 2,

    /**
     * 3. 商业版
     */
    COMMERICAL = 3,

    /**
     * 4. 企业版
     */
    ENTERPRISE = 4,

    /**
     * 5. 机构版
     */
    INSTITUTE = 5
}

export enum CardTheme {
    ROW = '1',
    COLUMN = '2'
}

export enum STUDENT_TYPE {
    /**
     * 假的
     */
    FAKE = 1,

    /**
     * 存在的
     */
    STUDENT = 2,

    /**
     * 未登录的
     */
    NOT_LOGIN = 3
}

/**
 * 模板样式类型
 */
export enum TemplateThemeType {
    /**
     * 个人版
     */
    Personal = 1,

    /**
     * 企业版
     */
    Enterprise = 2
}

export enum SEARCH_OBJ_TYPE {
    group = '1',
    program = '2',
    circle = '3',
    element = '5',
}

export enum OBJ_TYPE {
    group = 'group',
    program = 'program',
    circle = 'circle',
    element = 'element',// 小节
}

export enum PLATFORM {
    'twww' = 1,
    'mobile' = 2,
    'android' = 3,
    'ios' = 4
}

export enum LIST_TYPE {
    CORRELATION_LIST = 0,
    POPULAR_LIST = 1,
    NEW_LIST = 2
}

export enum MEETING_STATUS {
    NOT_STARTED = '0',
    ON_GOING = '1',
    END = '2'
}

export enum LIVE_TYPE {
    VIDEO = '1',
    AUDIO_ONLY = '2'
}

export enum COURSE_SESSION_LEARN_STATUS {
    PENDING = 0,
    ON_GOING = 1,
    DONE = 2
}

export enum COURSE_CHILD_TYPE {
    SESSION = 1,
    CHAPTER = 2
}

export enum ShareObjType {
    COURSE_PIC_SHARE = '101',
    COURSE_SHARE = '102',
    SESSION_PIC_SHARE = '103',
    SESSION_SHARE = '104',
    PROGRAM_PIC_SHARE = '105',
    PROGRAM_SHARE = '106',
    QUIZ_RANKING_PIC_SHARE = '107',
    QUIZ_RESULT_SHARE = '108',
    POINT_RANKING_PIC_SHARE = '109',
    SURVEY_RESULT_PIC_SHARE = '110',
    SURVEY_RESULT_SHARE = '111',
    LEANER_HOMEWORK = '112',
    QUIZ_RESULT_PIC_SHARE = '113',
    U_SHOW_TEMPLATE_CARD = '114',
    U_COURSE_CARD_SHARE = '115'
}

/**
 * 问题类型
 */
export enum ESurveySectionType {
    /**
     * 1 段落文本说明
     */
    PARAGRAPH = 1,

    /**
     * 2 单选题
     */
    RADIO = 2,

    /**
     * 3 多选题
     */
    CHECKBOX = 3,

    /**
     * 4 开放式问题（主观题）
     */
    TEXTAREA = 4,

    /**
     * 5 数值型问题
     */
    NUMBER = 5
}

export enum EOptionType {
    /**
     * 普通选项
     */
    NORMAL = 0,

    /**
     * 其它
     */
    OTHER = 1
}

/**
 * 问题 valid 的状态
 */
export enum ESectionValid {
    TRUE,
    IS_EMPTY,
    NOT_MEET_REQUIREMENT
}

/**
 * 问题类型 // todo 这个是标准的
 */
export enum ESectionType {
    /**
     * 段落文本说明
     */
    PARAGRAPH = 4,

    /**
     * 单选题
     */
    RADIO = 0,

    /**
     * 多选题
     */
    CHECKBOX = 1,

    /**
     * 开放式问题（主观题）
     */
    TEXTAREA = 3,

    /**
     * 开放式问题（客观题）
     */
    INPUT = 2
}

export enum SCORE_TYPE {
    NORMAL = 0,
    AI = 1,
    PARTIAL = 2
}

export enum API_TYPE {
    GET = 'get',
    POST = 'post',
    POSTFORMDATA = 'postFormData'
}

export enum DRAGGABLE_TYPE {
    WHOLE = 1,
    DRAGGABLE_PLAYED = 2
}

export enum CATEGORY_PANEL_TYPES {
    MAIN = 'main',
    CAROUSEL = 'carousel',
    CATEGORYL2 = 'channel_l2',
    HOTCOURSE = 'hot_course',
    HOTSESSION = 'hot_session',
    HOTCOMMENT = 'hot_comment',
    INFLUENCETERACHER = 'influence_teacher',
    RECOMMENDCIRCLE = 'recommend_circle',
    COURSEGROUPBYCATEGORYL2 = 'course_groupby_channel_l2',
    TOTAL_COURSE = 'total_course'
}

export enum MyLikeType {
    None,
    Like,
    UnLike
}

export enum ROLE {
    STUDENT = 0,
    TEACHER = 1
}

export enum CommentType {
    Text = 1,
    ImageContent = 2,
    RichContent = 3
}

export enum ECommentSortType {
    'HOTTEST' = 1,
    'LATEST' = 2,
    // 'TAG' = 3,
    'OLDEST' = 4
}

export enum ECommentStatus {
    /**
     * 0:待审核
     */
    'AUDIT' = 0,

    /**
     * 1:正常
     */
    'NORMAL' = 1,

    /**
     * 2:屏蔽
     */
    'BANDED' = 2
}

export enum ETagType {
    // 负值为本地的分类，会与 ECommentStatus 转换
    'BANDED' = -1,
    'AUDIT' = -2,

    'HOTTEST' = 1,
    'LATEST' = 2,
    // 'TAG' = 3,
    'OLDEST' = 4
}

export enum ISessionOrder {
    ASEND = 1,
    DESEND = 2
}

export enum ViewType {
    CREATOR = 'creator',
    LEARNER = 'learner'
}

/**
 * 视图状态
 */
export enum ViewType {
    /**
     * 查看
     */
    View = 1,

    /**
     * 编辑
     */
    Edit = 2
}

export enum RoleType {
    CREATOR = 'creator',
    COOPERATOR = 'cooperator',
    LEARNER = 'learner'
}

/**
 * 任务类型
 * 1 课程；2 小节；3 学习项目
 */
export enum TaskType {
    /**
     * 1 课程；
     */
    COURSE = 1,
    /**
     * 2 小节；
     */
    ELEMENT = 2,
    /**
     * 3 学习项目
     */
    PROGRAM = 3
}

/**
 * 分享类型
 */
export enum ShareType {
    /**
     * 1 班级；
     */
    CLASS = '1',
    /**
     * 2 课程；
     */
    GROUP = '2',
    /**
     * 3 课程排行；
     */
    GROUP_RANK = '3',
    /**
     * 4 勋章；
     */
    MEDAL = '4',
    /**
     * 5 大数据；
     */
    BIG_DATA = '5',
    /**
     * 6证书
     */
    CERTIFICATION = '6',
    /**
     * 7学习项目
     */
    PROGRAM = '7',
    /**
     * 8小节
     */
    SESSION = '8',

    /**
     * 问卷结果
     */
    SURVEY_RES = '9',

    /**
     * 考试答案
     */
    QUIZ_ANSWER = '10',
    INFLUENCE = '11',
    /**
     * 学习项目学习证书
     */
    PROGRAM_CERTIFICATION = '13',
    /**
     * 圈子相关
     */
    CIRCLE = '21',
    CIRCLE_ACHIEVEMENT = '22',
    CIRCLE_TOPIC = '23',

    /**
     * 年度报告
     */
    ACTIVITY_ANNUAL_2020 = '24',

    /**
     * 个人主页留言
     */
    PROFILE_MESSAGE = '25',

    /**
     * 年度报告2021
     */
    ACTIVITY_ANNUAL_2021 = '26',

    /**
     * 企业证书
     */
    ENTERPRISE_CERTIFICATE = '27',

    // 这几个以 OLD 开头的是旧的分享类型，与上面的区别在于上面的分享类型是用于 Api.SHARE_IMG api 的，但这几个分享类型是单独的 API，为了收敛逻辑，把它们统一都抽取到了这里
    OLD_COURSE_RANK_SHARE = '100',
    OLD_REPORT_SHARE = '101',
    OLD_EXAM_RANK_SHARE = '102',
    OLD_CERTIFICATE_SHARE = '103',
}

// 分享对象(obj_type)
export enum EAppShareType {
    CLASS = 'class',
    GROUP = 'group',
    PROGRAM = 'program',
    SESSION = 'session',
    QUESTION = 'question',
    HOMEWORK = 'homework',
    LEARNING_CIRCLE = 'learningCircle',
    IMG = 'image'
}

export enum ShareThemeType {
    THEME_CODE = 1,
    THEME_COMMON = 2,
    THEME_ACHIENEMENT = 3,

    /**
     * 课程分享默认
     */
    THEME_CUSTOM_SHARE = 4,

    /**
     * 课程激励默认
     */
    THEME_CUSTOM_EXCITATION = 5
}

/**
 * 资源可用状态
 */
export enum ResourceStatus {
    IN_USE = 'in_use',
    WAIT_TRANSCODING = 'wait_transcoding',
    TRANSCODING_FAIL = 'transcoding_fail'
}

export enum SortType {
    /**
     * 正序
     */
    ASC = 'asc',

    /**
     * 逆序
     */
    DESC = 'desc'
}

export enum HomeworkSubmitStatus {
    /**
     * 不提交
     */
    save = 0,
    /**
     * 提交
     */
    submit = 1
}

export enum MediaType {
    IMAGE = 1,
    AUDIO = 2,
    VIDEO = 3
}

// 资源类型
export enum ResourceType {
    /**
     * 视频微课
     */
    MICROCOURSE_VIDEO = 1,

    /**
     * 文档
     */
    DOC = 2,

    /**
     * 直播流
     */
    LIVE_STREAM = 3,

    /**
     * 图文微课资源
     */
    IMAGE_TEXT = 4,

    /**
     * 语音微课
     */
    MICROCOURSE_AUDIO = 5,

    /**
     * 封面图
     */
    BANNER_IMAGE = 6,

    /**
     * 富文本资源ID
     */
    MULTIPMEDIA_ID = 7,

    /**
     * element 图片
     */
    IMAGE = 8,
    // TODO: 待定

    /**
     * element 图片
     */
    ARTICLE = 15,

    /**
     * 语音微课转视频
     */
    VOICE_MINI_COURSE_TO_VIDEO = 9,

    /**
     * 作业范例视频
     */
    HOMEWORK_SAMPLE_VIDEO = 10,

    /**
     * 语音微课-涂鸦线条
     */
    MICROCOURSE_ACTION_SEGMENT = 13,

    /**
     * 语音微课-涂鸦文字
     */
    MICROCOURSE_ACTION_TEXT = 14,

    /**
     * 段落说明的富文本 ID\
     */
    PARAGRAPH_MULTIPMEDIA_ID = 15,
    /**
     * ai微课
     */
    AI_AUDIO_SLIDES = 16
}

/**
 * 业务对象类型
 */
export enum BusinessObjectIdType {
    GROUP_ID = 1,
    FOLDER_ID = 2,
    PROGRAM_ID = 3,
    ELEMENT_ID = 4,
    QUESTION_ID = 5
}

/**
 * 作业类型
 */
export enum HomeworkType {
    /**
     * 音频作业
     */
    AUDIO = '1',

    /**
     * 视频作业
     */
    VIDEO = '2',

    /**
     * 图文作业
     */
    IMGTXT = '3',

    /**
     * 文档作业
     */
    DOC = '4',

    /**
     * 动作练习
     */
    GESTURE = '5'
}

/**
 * 问卷类型
 */
export enum PollType {
    /**
     * 1、作业评价问卷模板
     */
    HOMEWORK_EVAL_POLL_TEMPLATE = 1,

    /**
     * 2、作业评价问卷
     */
    HOMEWORK_EVAL_POLL = 2
}

/**
 * 用户成长值中 弹窗类型
 * @see https://docs.google.com/document/d/1igztR_t52T1XNtWUNpS45AxFTV6peg6uOP8vx0dgJFU/edit#
 */
export enum AchivementDialogType {
    /**
     * 每日登录
     */
    DAILY_LOGIN = 'daily_login',

    /**
     * 用户等级
     */
    USER_LEVEL = 'user_level',

    /**
     * 用户勋章
     */
    USER_MEDAL = 'user_medal',
    /**
     * 自定义运营弹框
     */
    POPUP_CUSTOM = 'user_custom',
    LEVEL_PRIVILEGE_OFFLINE = 'user_level_privilege_offline',
    INVITE_ENTERPRISE = 'invite_to_join_enterprise_show',
    /**
     * 用户到期提醒
    */
    ENTERPRISE_EXPIRE = 'enterprise_expire',
    /**
     * 官方公告弹窗
    */
    OFFICIAL_POPUP = 'official_popup',
}

// 长连接的业务类型
export enum SocketBusinessType {
    /**
     * 直播
     */
    LIVE = 1,

    /**
     * 大屏幕问卷
     */
    SURVEY_SCREEN = 2,

    /**
     * 私信
     */
    PRIVATE_MESSAGE = 3
}

// 长连接消息类型
export enum SocketType {
    SURVEY_UPDATE_STATUS = 300,
    SURVEY_UPDATE_SETUP = 301,
    ANCHOR_DISCONNECTED = 4,

    // 私信接收消息
    RECEIVE_PRIVATE_MESSAGE = 400,

    PLATFORM_TEACHER_CHANGED = 302
}

export enum EnterpriseRoleType {
    /**
     * 子系统管理员
     */
    SUB_ADMIN = 5,
    /**
     * 系统管理员
     */
    ADMIN = 4,

    /**
     * 学习负责人
     */
    MANAGE = 3,

    /**
     * 讲师
     */
    TEACHER = 2,

    /**
     * 学员
     */
    LEARNER = 1
}

export enum IS {
    TRUE = '1',
    FALSE = '0'
}

export enum DeniedType {
    COMMON = 'common',

    /**
     * 企业版权限
     */
    ENT = 'ent'
}

/**
 * 课程拒绝访问页面page_type
 */
export enum DeniedPageType {
    /**
     * 课程市场 外部课程 已过期
     */
    OUTER_GROUP_CLOSE = 'outer_group_close',

    /**
     * 课程关闭
     */
    GROUP_CLOSE = 'group_close'
}

/**
 * 报名类型
 */
export enum EnrollType {
    CIRCLE = 1
}

/**
 * 报名的具体状态
 */
export enum EnrollStatus {
    /**
     * 未开始报名
     */
    UNKNOWN = 0,

    /**
     * 付费报名，待支付
     */
    PAY_WAIT = 1,

    /**
     * 付费报名，支付成功, 待审核（手动审核）
     */
    PAYMENT_PENDING_APPROVE = 2,

    /**
     * 支付失败
     */
    PAY_FAIL = 3,

    /**
     * 未缴费等待审核
     */
    NO_PAYMENT_PENDING_APPROVE = 4,

    /**
     * 未支付,审核通过
     */
    NO_PAYMENT_AFTER_APPROVE = 5,

    /**
     * 支付后,审核通过
     */
    PAYMENT_AFTER_APPROVE = 6,

    /**
     * 未支付审核失败
     */
    NO_PAYMENT_REJECT_APPROVE = 7,

    /**
     * 等待退款
     */
    WAIT_REFUND = 8
}

/**
 * 首次报名 or 续费
 */
export enum PayType {
    FIRST = '1',
    RENEWAL = '2'
}

/**
 * 0.  新用户
 *    1.  基本版
 *   - C端免费注册账户，不显示到期时间
 *   - App展示为 基本版
 *   2.  高级版
 *   - 付费高级版，显示到期时间，过期后变为基本版
 *   - App展示为 高级版
 *  3.  未验证邮件用户
 *  4.  VIP 高级版(非付费)
 *  - 非付费升级高级版，显示到期时间，过期后变为基本版
 *  - App展示为高级版
 *   5. 教育版 基本版
 *   - “教育版 高级版”到期后，展示为“教育版 基本版”，可以联络用户升级
 *   - App展示为 基本版
 *   6.  教育版 高级版
 *   - 教育版升级用户，显示到期时间，过期后显示为“教育版 基本版”
 *   - App展示为 高级版
 *   7.  企业版
 *   8.  企业版 试用版
 *   - 多语言以及之前CN企业版可以注册企业版试用账户，并有两个子账户
 *   9. 商用版
 *   10. 商用版试用
 */
export enum VERSION_TYPE {
    /**
     * 新用户
     */
    NEW_ACCOUNT = 0,
    /**
     * 基本版 - C端免费注册账户，不显示到期时间
     */
    NORMAL = 1,

    /**
     * 专业版 - C端高级账户，付费升级而来，显示到期时间，过期后变为基本版
     */
    PROFESSIONAL = 2,
    /**
     * 未验证邮件用户
     */
    UNVERIFIED_EMAIL = 3,
    /**
     * 免费的高级版，由运营人员开通，显示到期时间，过期后变为基本版，功能和 C_VIP 一样
     */
    FREE_PROFESSIONAL = 4,

    /**
     * 教育基本版
     */
    EDU_BASIC = 5,

    /**
     * 教育专业版 - 教育版升级用户，显示到期时间，过期后显示为“教育版 基本版”
     */
    EDU_PROFESSIONAL = 6,

    /**
     * 企业版
     * 不显示 “升级”
     */
    ENTERPRISE = 7,

    /**
     * 企业版 试用版
     */
    ENTERPRISE_TRIAL = 8,

    /**
     * 商用版(团队版)
     * 不显示 “升级”
     */
    COMMERICAL = 9,

    /**
     * 商用版(团队版) 试用
     */
    COMMERICAL_TRIAL = 10,

    /**
     * 企业版 通用版
     */
    ENTERPRISE_COMMON = 11,

    /**
     * 机构版
     */
    INSTITUTE = 12,

    /**
     * 机构版 通用版
     */
    INSTITUTE_COMMON = 13
}

export enum ENTERPRISE_ROLE {
    /**
     * C 端管理员
     */
    A_ADMIN = 9,

    /**
     * 系统管理员
     */
    ADMIN = 4,

    /**
     * 学习负责人
     */
    DIRECTOR = 3,

    /**
     * 讲师
     */
    TEACHER = 2,

    /**
     *
     */
    LEARNER = 1
}

export enum ELikedStatus {
    NOT_LIKED,
    LIKED
}

export enum DomType2SectionTypeMap {
    /**
     * 段落文本说明
     */
    paragraph = 1,

    /**
     * 单选题
     */
    radio = 2,

    /**
     * 多选题
     */
    checkbox = 3,

    /**
     * 开放式问题（主观题）
     */
    textarea = 4,

    /**
     * 数值型问题
     */
    number = 5
}

export enum QUIZ_ANSWER_LEVEL {
    EXCELLENT = 'excellent',
    GOOD = 'good',
    FAIL = 'failure'
}

/**
 * @description 举报类型
 */
export enum REPORT_TYPE {
    CONTENT_BLOCK = 'content',
    USER = 'user'
}

/**
 * @description 被举报对象的分类
 */
export enum REPORT_CATEGORY_TYPE {
    /**
     * @description 学习圈主题
     */
    LEARNING_CIRCLE_TOPIC = 'CIRTOPIC',
    /**
     * @description 主题回复
     */
    LEARNING_CIRCLE_TOPIC_REPLY = 'CIRCMT',
    /**
     * @description 提问回复
     */
    LEARNING_CIRCLE_ANSWER = 'CIRANSW',
    /**
     * @description 学习圈问答
     */
    LEARNING_CIRCLE_QUESTION = 'CIRQUE',
    /**
     * @description 小节评论
     */
    ELEMENT_COMMENT = 'SESSCMT',
    /**
     * @description 小节回复
     */
    ELEMENT_REPLY = 'SESSRLY',
    /**
     * @description 用户
     */
    USER = 'USER',
    /**
     * @description 小节回复
     */
    NOTE = 'NOTE',
    /**
     * @description 作业小节回复
     */
    HOMEWKCMT = 'HOMEWKCMT'
}

/**
 * 微信环境
 */
export enum WX_ENV {
    /**
     * 非微信 = 0
     */
    UNKNOWN = '0',

    /**
     * 微信 = 1
     */
    WX = '1',

    /**
     * 企业微信 = 2
     */
    WX_WORK = '2'
}

/**
 * feed 类型
 */
export enum FeedType {
    NOTICE = '1',
    COURSE_TASK = '2',
    ELEMENT_TASK = '3',
    PROGRAM_TASK = '4',

    COURSE_PIC_SHARE = '101',
    COURSE_SHARE = '102',
    SESSION_PIC_SHARE = '103',
    SESSION_SHARE = '104',
    PROGRAM_PIC_SHARE = '105',
    PROGRAM_SHARE = '106',
    QUIZ_RANKING_PIC_SHARE = '107',
    /**
     * 考试结果
     */
    QUIZ_RESULT_SHARE = '108', //
    POINT_RANKING_PIC_SHARE = '109',
    SURVEY_RESULT_PIC_SHARE = '110',
    SURVEY_RESULT_SHARE = '111',
    LEANER_HOMEWORK = '112',
    QUIZ_RESULT_PIC_SHARE = '113',
    U_SHOW_TEMPLATE_CARD = '114',
    U_COURSE_CARD_SHARE = '115'
}

// 查找类别， delete： 0：全部 1：班级通知；2：学习任务-课程；3：学习任务-小节；4：学习任务-学习项目；
/**
 * Feed流类型
 */
export enum FEED_FILTER_TYPE {
    ALL = 0,

    /**
     * 1：通知
     */
    NOTICE = 1,

    /**
     * 2：小节
     */
    ELEMENT = 2,

    /**
     * 3：课程
     */
    COURSE = 3,

    /**
     * 4：学习项目
     */
    PROGRAM = 4,

    /**
     * 5：图片
     */
    PIC = 5
}

/**
 * @file 请求后端错误码
 * @author liudy
 */

export enum RequestErrorCode {
    /**
     * 你已为当前作业评分，请勿重复评分
     */
    homeworkScoreDuplicate = 31002 //
}

export enum ERROR_CODE {
    SUCCESS = 0,
    ERROR = 1,

    /**
     * 发布频率过高
     */
    POST_FREQUENT = 400,

    /**
     * 服务器错误
     */
    SERVER_ERROR = 500,

    NO_LOGIN = 30002,

    SURVEY_SAVE_NO_LOGIN = 10002103,

    /**
     * 有敏感词
     */
    HAS_SENSITIVE_WORDS = 10004,

    /**
     * 无学习圈创建权限
     */
    CIRCLE_UNHAS_CREATE_PERMISSION = 990010,

    /**
     * 圈子已上推荐位
     */
    CIRCLE_RECOMMENDED = 990201,

    /**
     * 学习圈置顶数据量超出
     */
    CIRCLE_TOP_OVER_LIMIT = 990302,

    /**
     * task generator 已删除
     */
    CIRCLE_TASK_HAS_DELETED = 40001,

    /**
     * 打卡天数为空
     */
    DAYS_EMPTY = 40008,

    /**
     * 开始时间在今天之前
     */
    START_TIME_BEFORE_UPDATE = 40009,

    /**
     * 没有权限创建
     */
    NO_AUTH_CREATE_TASK = 40010,

    /**
     *
     */
    CIRCLE_HAS_REPORT_CAN_NOT_DELETE = 40011,

    /**
     * task不存在
     */
    CIRCLE_TASK_NOT_EXIST = 40013,

    /**
     * task 没有在提醒时间
     */
    CIRCLE_CHECKIN_NOT_TIME = 40014,

    /**
     * 学习圈不存在
     */
    CIRCLE_NOT_EXIST = 40018,

    /**
     * 该任务已打卡
     */
    CIRCLE_TASK_REPORT_HAS_CHECKIN = 40019,

    /**
     * 打卡时间已过期
     */
    CIRCLE_TASK_CHECKIN_EXPIRED = 40020,

    /**
     * 测评 会直接报无权限的错误码40004.http://api.umucdn.cn/project/291/interface/api/4283
     */
    ASSESSMENT_NO_PERMISSION_ASSESS = 40004, // 有敏感词

    /**
     * 用户访问的测评中的测评方案被删除了
     */
    ASSESSMENT_PROJECT_DELETED = 20101,

    // 举报相关的

    /**
     * 没有权限
     */
    NO_PERMISSION = 10001,

    /**
     * 没有登录
     */
    NOT_LOGGED_IN = 100401,

    /**
     * 错误参数
     */
    WRONG_PARAMETERS = 100304,

    /**
     * 用户举报内容超10条/天
     */
    REPORT_OVER_LIMIT = 110101,
    /**
     * 用户重复举报内容
     */
    REPORT_REPEAT = 110102,
    /**
     * 不能举报自己的内容
     */
    REPORT_SELF = 110103,

    /**
     * 找不到对象
     */
    DONT_FOUND_OBJECT = 110104,

    /**
     * 参数不支持
     */
    PARAMETER_NOT_SUPPORTED = 110105,

    /**
     * 客户授权免密登录
     */
    DEBUG_AUTH = 110111,

    PRIVATE_MESSAGE_CHANGE_ACCOUNT = 10500000,
    PRIVATE_MESSAGE_CLOSED = 10500001,
    PRIVATE_MESSAGE_LEAVE_ENTERPRISE = 10500002,
    PRIVATE_MESSAGE_ACCOUNT_LOGOUT = 10500003,
    PRIVATE_MESSAGE_WITH_C = 10500007,

    SESSION_IS_EDITED = 40001345
}

export enum CommentParentType {
    /**
     * 作业
     */
    HOMEWORK = 1,

    /**
     * 作业评论
     */
    HOMEWORK_EVALUATE = 2,

    /**
     * 作业时间线点评
     */
    HOMEWORK_TIMELINE = 3,

    /**
     * 小节学习笔记
     */
    ELEMENT_COMMENT = 4,

    /**
     * 班级动态评论
     */
    CLASS_FEED_COMMENT = 5,

    /**
     * 学习圈动态评论
     */
    LEARNING_CIRCLE_COMMENT = 6
}

export enum CommentSubjectType {
    /**
     * 问题类型
     */
    QUESTION = 0,

    /**
     * 小节照片类型
     */
    ELEMENT_PHOTO = 1,

    /**
     * 班级feed类型
     */
    CLASS_FEED = 2,

    /**
     * 学习圈feed类型
     */
    LEARNING_CIRCLE_FEED = 3
}

export enum EPracticeQuestionStatus {
    /**
     * 未加入
     */
    DEFAULT = 0,

    /**
     * 易错题
     */
    COLLECTED = 1,

    /**
     * 已收藏
     */
    PRACTICED = 2
}

export enum PARTICIPATE_STATUS {
    /**
     * 默认，没有设置开始结束时间，随时可以参与
     */
    ONBEFORE = 0,

    /**
     * 未开始
     */
    ONSTART = 1,

    /**
     * 进行中
     */
    PENDING = 2,

    /**
     * 已结束
     */
    ONEND = 3
}

export enum EMediaType {
    /**
     * 图文微课的头图
     */
    PIC_WEIKE = 'picweike',

    /**
     * 用户头像的图片
     */
    IMAGE = 'image',

    /**
     * 视频微课的视频
     */
    VIDEO_WEIKE = 'videoweike',

    /**
     * 文档作业的文档
     */
    DOC_WEIKE = 'docweike',

    /**
     * 语音微课的讲稿图片
     */
    IMAGE_WEIKE = 'imageweike',

    /**
     * 拍照上墙的图片
     */
    IMAGE_WALL = 'imagewall',

    /**
     * 语音微课的涂鸦文字和线条资源
     */
    WEIKE_GRAFFITI = 'graffiti',

    /**
     * 语音微课的mp3资源
     */
    WEIKE_AUDIO = 'audio',

    /**
     * 字幕srt资源
     */
    SUBTITLE = 'subtitle'
}

export enum EPlayState {
    buffering,
    idle,
    playing,
    paused
}

/**
 * m端发送给app，以2000 为基准，id顺序递增
 * https://wiki.umu.work/pages/viewpage.action?pageId=13369616
 */
export enum SendMsgType {
    /**
     * app关闭时
     */
    onClassDeleted = 1004,

    /**
     * 提交作业评分
     */
    onSubmitHomeworkEvaluate = 1005,

    /**
     * 取消作业评分
     */
    onCancelHomeworkEvaluate = 1006,

    /**
     * 提交课程证书编辑
     */
    onSubmitCourseCertificateEdit = 1008,

    /**
     * android 是否点击了回退按钮
     */
    onAppBack = 1009, // 1102,

    /**
     * android/ios 是否点击了导航上的返回
     */
    onNavBack = 1010,

    /**
     * 关闭app
     */
    closeApp = 2001,

    /**
     * 初始化信息
     */
    initAppData = 2002,

    /**
     * 关闭app 评价弹窗
     */
    onCancelAppHomeworkEval = 1007,

    /**
     * 跳转到班级协同页
     */
    classAddTeachers = 2003,

    /**
     * 跳转到班级添加学员页
     */
    classAddStudents = 2004,

    /**
     * 跳转到app创建班级页
     */
    classCreate = 2005,

    /**
     * 1101 隐藏/显示native导航
     */
    toggleAppBar = 2006,

    /**
     * 用户单击物理键后，native是继续其默认动作
     */
    defaultAppBackBackContinue = 2007,

    /**
     * 通知app端监听appNavBar上的返回
     */
    setListenAppNarBack = 2008,

    // 学习圈相关
    /**
     * walkthrough 选择完成
     */
    walkthroughCompleted = 2009,

    /**
     * 通过 native 来进行重定向(webview)
     */
    redirectByNative = 2010,

    /**
     * native 导航切换到 “精选”
     */
    toNativeCircleMarket = 2011,

    /**
     * 关掉当前页面并重定向
     */
    closeAndRedirect = 2012,

    /**
     * 通过 native 下载资源
     */
    downloadByNative = 2013,

    // 举报相关
    /**
     * app获取个人页的举报信息
     */
    reportProfileInfo = 2014,

    /**
     * 启用/禁用App下拉刷新
     */
    enablePullToRefresh = 2015,

    /**
     * 去私信聊天
     */
    goPrivateChat = 2017,

    /**
     * 去消息中心
     */
    goMsgCenter = 2018,

    backPrevPage = 2021,
    
    /**
     * 去个人资料编辑页
     * 最低app版本6.5.1
     */
    goProfile = 2022,
    /**
     * 定价页去 APP 购买
     */
    goVersionPurchase = 2023,
    /**
     * 作业圈划点评
     */
    goHomeworkFeedback = 3001,

    /**
     * app 活动状态
     */
    appActiveStatus = 4000,

    /**
     * @description: UGC 屏蔽通知
     */
    ugcBlock = 1011,
    /**
     * @description: UGC 屏蔽入口
     */
    ugcBlockEntry = 2025,
}

export enum TOOGLE_TYPE {
    SHOW = 1,
    HIDE = 2
}

export enum UpvoteType {
    NORMAL = 'normal',
    COMMENT = 'comment',
    DARK = 'dark',
    WHITE = 'white',
    LINE = 'line'
}

// 当赞数为0时，文案展示类型，默认是TEXT_LIKE
export enum LikeZeroShowType {
    /**
     *  ‘赞’
     */
    TEXT_LIKE,

    /**
     * 展示的文案为0
     */
    ZERO
}

export enum ETiedShareType {
    SHARE_CARD = 'SHARE_CARD',
    SHARE_TO_CLASS_PAGE = 'SHARE_TO_CLASS_PAGE'
}

export enum ArrowDirection {
    UP = 'up',
    RIGHT = 'right',
    DOWN = 'down',
    LEFT = 'left'
}

export enum PageDirection {
    Next = 1,
    Prev = -1,
    Resize = 0
}

export enum ECollectionType {
    COURSE = 1,
    ELEMENT = 2
}

export enum IndexModuleType {
    CAROUSE = 1,
    RECOMMEND = 2,
    PROGRAM = 3,
    NAV = 4,
    CUSTOM = 5,
    LEARN_TASK = 6,
    CUSTOM_TEXT = 7,
    AI_RECOMMEND = 10,
    AI_RECOMMEND_COURSE = 11
}

export enum EPlatformTravelType {
    department = 'department', // 部门模式
    owner = 'owner' // 负责人模式
}
export enum EPlatformSectionType {
    left = 'left', // 部门模式
    right = 'right' // 负责人模式
}

export enum EPlatformRoleType {
    admin = 2, // 负责人
    ordinary = 1, // 普通
    unknown = 0 // 未知
}

export enum ECommonActionType {
    'TEST' = 'TEST',
    'TEST_START' = 'TEST_START',
    'TEST_SUCCESS' = 'TEST_SUCCESS',
    'TEST_FAIL' = 'TEST_FAIL',

    'TOGGLE_SCORE_LAYER' = 'TOGGLE_SCORE_LAYER',
    'TOGGLE_SCORE_LAYER_SUCCESS' = 'TOGGLE_SCORE_LAYER_SUCCESS',

    'ON_GET_HOMEWORK_INFO' = 'ON_GET_HOMEWORK_INFO',
    'ON_GET_HOMEWORK_INFO_START' = 'ON_GET_HOMEWORK_INFO_START',
    'ON_GET_HOMEWORK_INFO_SUCCESS' = 'ON_GET_HOMEWORK_INFO_SUCCESS',
    'ON_GET_HOMEWORK_INFO_FAIL' = 'ON_GET_HOMEWORK_INFO_FAIL',

    'SUBMIT_SCORE' = 'SUBMIT_SCORE',
    'SUBMIT_SCORE_START' = 'SUBMIT_SCORE_START',
    'SUBMIT_SCORE_SUCCESS' = 'SUBMIT_SCORE_SUCCESS',
    'SUBMIT_SCORE_FAIL' = 'SUBMIT_SCORE_FAIL',

    'UPDATE_HOMEWORK_INFO' = 'UPDATE_HOMEWORK_INFO',
    'UPDATE_HOMEWORK_INFO_SUCCESS' = 'UPDATE_HOMEWORK_INFO_SUCCESS',

    'GET_TIMELINE_STAT_USER_LIST' = 'GET_TIMELINE_STAT_USER_LIST',
    'GET_TIMELINE_STAT_USER_LIST_START' = 'GET_TIMELINE_STAT_USER_LIST_START',
    'GET_TIMELINE_STAT_USER_LIST_SUCCESS' = 'GET_TIMELINE_STAT_USER_LIST_SUCCESS',
    'GET_TIMELINE_STAT_USER_LIST_FAIL' = 'GET_TIMELINE_STAT_USER_LIST_FAIL',

    'GET_TIMELINE_COMMENT_LIST' = 'GET_TIMELINE_COMMENT_LIST',
    'GET_TIMELINE_COMMENT_LIST_START' = 'GET_TIMELINE_COMMENT_LIST_START',
    'GET_TIMELINE_COMMENT_LIST_SUCCESS' = 'GET_TIMELINE_COMMENT_LIST_SUCCESS',
    'GET_TIMELINE_COMMENT_LIST_FAIL' = 'GET_TIMELINE_COMMENT_LIST_FAIL',

    'UPDATE_CURRENT_FILTER_USER' = 'UPDATE_CURRENT_FILTER_USER',
    'UPDATE_CURRENT_FILTER_USER_SUCCESS' = 'UPDATE_CURRENT_FILTER_USER_SUCCESS',

    // 跳转播放
    'SEEK_PLAYER_TIME' = 'SEEK_PLAYER_TIME',
    'SEEK_PLAYER_TIME_SUCCESS' = 'SEEK_PLAYER_TIME_SUCCESS',

    // 视频作业
    'SUBMIT_COMMENT' = 'SUBMIT_COMMENT',
    'SUBMIT_COMMENT_START' = 'SUBMIT_COMMENT_START',
    'SUBMIT_COMMENT_SUCCESS' = 'SUBMIT_COMMENT_SUCCESS',
    'SUBMIT_COMMENT_FAIL' = 'SUBMIT_COMMENT_FAIL',

    // 图文作业
    'IMAGE_ARTICLE_COMMENT_NOTE' = 'IMAGE_ARTICLE_COMMENT_NOTE',
    'IMAGE_ARTICLE_COMMENT_NOTE_SUCCESS' = 'IMAGE_ARTICLE_COMMENT_NOTE_SUCCESS',

    'IMAGE_ARTICLE_COMMENT_CLEAR' = 'IMAGE_ARTICLE_COMMENT_CLEAR',
    'IMAGE_ARTICLE_COMMENT_CLEAR_SUCCESS' = 'IMAGE_ARTICLE_COMMENT_CLEAR_SUCCESS',

    'SUBMIT_IMAGE_ARTICLE_COMMENT' = 'SUBMIT_IMAGE_ARTICLE_COMMENT',
    'SUBMIT_IMAGE_ARTICLE_COMMENT_START' = 'SUBMIT_IMAGE_ARTICLE_COMMENT_START',
    'SUBMIT_IMAGE_ARTICLE_COMMENT_SUCCESS' = 'SUBMIT_IMAGE_ARTICLE_COMMENT_SUCCESS',
    'SUBMIT_IMAGE_ARTICLE_COMMENT_FAIL' = 'SUBMIT_IMAGE_ARTICLE_COMMENT_FAIL',

    'GET_HOMEWORK_IMAGE_TEXT_LIST' = 'GET_HOMEWORK_IMAGE_TEXT_LIST',
    'GET_HOMEWORK_IMAGE_TEXT_LIST_START' = 'GET_HOMEWORK_IMAGE_TEXT_LIST_START',
    'GET_HOMEWORK_IMAGE_TEXT_LIST_SUCCESS' = 'GET_HOMEWORK_IMAGE_TEXT_LIST_SUCCESS',
    'GET_HOMEWORK_IMAGE_TEXT_LIST_FAIL' = 'GET_HOMEWORK_IMAGE_TEXT_LIST_FAIL',

    // 语音作业
    'SYNC_MICROCOURSE_COMMENT' = 'SYNC_MICROCOURSE_COMMENT',
    'SYNC_MICROCOURSE_COMMENT_SUCCESS' = 'SYNC_MICROCOURSE_COMMENT_SUCCESS',

    'CLEAR_MICROCOURSE_COMMENT' = 'CLEAR_MICROCOURSE_COMMENT',
    'CLEAR_MICROCOURSE_COMMENT_SUCCESS' = 'CLEAR_MICROCOURSE_COMMENT_SUCCESS',

    'SUBMIT_MICROCOURSE_COMMENT' = 'SUBMIT_MICROCOURSE_COMMENT',
    'SUBMIT_MICROCOURSE_COMMENT_START' = 'SUBMIT_MICROCOURSE_COMMENT_START',
    'SUBMIT_MICROCOURSE_COMMENT_SUCCESS' = 'SUBMIT_MICROCOURSE_COMMENT_SUCCESS',
    'SUBMIT_MICROCOURSE_COMMENT_FAIL' = 'SUBMIT_MICROCOURSE_COMMENT_FAIL',

    // 内容类阅读速度
    'DOC_READ_SPEED_RESET' = 'DOC_READ_SPEED_RESET',
    'DOC_READ_SPEED_RESET_SUCCESS' = 'DOC_READ_SPEED_RESET_SUCCESS',

    'DOC_READ_SPEED_START' = 'DOC_READ_SPEED_START',
    'DOC_READ_SPEED_START_SUCCESS' = 'DOC_READ_SPEED_START_SUCCESS',

    'DOC_READ_SPEED_COMPLETE' = 'DOC_READ_SPEED_COMPLETE',
    'DOC_READ_SPEED_COMPLETE_SUCCESS' = 'DOC_READ_SPEED_COMPLETE_SUCCESS',

    'DOC_READ_SPEED_CALCULATE' = 'DOC_READ_SPEED_CALCULATE',
    'DOC_READ_SPEED_CALCULATE_START' = 'DOC_READ_SPEED_CALCULATE_START',
    'DOC_READ_SPEED_CALCULATE_SUCCESS' = 'DOC_READ_SPEED_CALCULATE_SUCCESS',
    'DOC_READ_SPEED_CALCULATE_FAIL' = 'DOC_READ_SPEED_CALCULATE_FAIL',

    // 播放器状态
    'ON_UPDATE_PLAYER_CURRENT_TIME' = 'ON_UPDATE_PLAYER_CURRENT_TIME',
    'ON_UPDATE_PLAYER_CURRENT_TIME_SUCCESS' = 'ON_UPDATE_PLAYER_CURRENT_TIME_SUCCESS',

    'ON_UPDATE_PLAYER_PLAY_STATE' = 'ON_UPDATE_PLAYER_PLAY_STATE',
    'ON_UPDATE_PLAYER_PLAY_STATE_SUCCESS' = 'ON_UPDATE_PLAYER_PLAY_STATE_SUCCESS',

    'ON_PLAYER_STATE_START' = 'ON_PLAYER_STATE_START',
    'ON_PLAYER_STATE_START_SUCCESS' = 'ON_PLAYER_STATE_START_SUCCESS',

    'ON_PLAYER_STATE_PLAYING' = 'ON_PLAYER_STATE_PLAYING',
    'ON_PLAYER_STATE_PLAYING_SUCCESS' = 'ON_PLAYER_STATE_PLAYING_SUCCESS',

    'ON_PLAYER_STATE_END' = 'ON_PLAYER_STATE_END',
    'ON_PLAYER_STATE_END_SUCCESS' = 'ON_PLAYER_STATE_END_SUCCESS',

    // 图文提示浮层点击记录
    'ON_CLICK_AD' = 'ON_CLICK_AD',
    'ON_CLICK_AD_START' = 'ON_CLICK_AD_START',
    'ON_CLICK_AD_SUCCESS' = 'ON_CLICK_AD_SUCCESS',
    'ON_CLICK_AD_FAIL' = 'ON_CLICK_AD_FAIL',

    // 点赞
    'PRISE_CREATOR' = 'PRISE_CREATOR',
    'PRISE_CREATOR_START' = 'PRISE_CREATOR_START',
    'PRISE_CREATOR_SUCCESS' = 'PRISE_CREATOR_SUCCESS',
    'PRISE_CREATOR_FAIL' = 'PRISE_CREATOR_FAIL',

    // 词云列表
    'GET_TAG_CLOUD_LIST' = 'GET_TAG_CLOUD_LIST',
    'GET_TAG_CLOUD_LIST_START' = 'GET_TAG_CLOUD_LIST_START',
    'GET_TAG_CLOUD_LIST_SUCCESS' = 'GET_TAG_CLOUD_LIST_SUCCESS',
    'GET_TAG_CLOUD_LIST_FAIL' = 'GET_TAG_CLOUD_LIST_FAIL',

    // 听众信息
    'GET_WEIKE_LISTENER_LISTENED_INFO' = 'GET_WEIKE_LISTENER_LISTENED_INFO',
    'GET_WEIKE_LISTENER_LISTENED_INFO_START' = 'GET_WEIKE_LISTENER_LISTENED_INFO_START',
    'GET_WEIKE_LISTENER_LISTENED_INFO_SUCCESS' = 'GET_WEIKE_LISTENER_LISTENED_INFO_SUCCESS',
    'GET_WEIKE_LISTENER_LISTENED_INFO_FAIL' = 'GET_WEIKE_LISTENER_LISTENED_INFO_FAIL',

    'GET_WEIKE_LISTENER_LISTENING_INFO' = 'GET_WEIKE_LISTENER_LISTENING_INFO',
    'GET_WEIKE_LISTENER_LISTENING_INFO_START' = 'GET_WEIKE_LISTENER_LISTENING_INFO_START',
    'GET_WEIKE_LISTENER_LISTENING_INFO_SUCCESS' = 'GET_WEIKE_LISTENER_LISTENING_INFO_SUCCESS',
    'GET_WEIKE_LISTENER_LISTENING_INFO_FAIL' = 'GET_WEIKE_LISTENER_LISTENING_INFO_FAIL',

    // 跨组件展示笔记浮层
    'TOGGLE_SHOW_NOTE_COMPOSTER' = 'TOGGLE_SHOW_NOTE_COMPOSTER',
    'TOGGLE_SHOW_NOTE_COMPOSTER_SUCCESS' = 'TOGGLE_SHOW_NOTE_COMPOSTER_SUCCESS',

    // 展示笔记分享浮层
    'TOGGLE_SHOW_NOTE_SHARE_LAYER' = 'TOGGLE_SHOW_NOTE_SHARE_LAYER',
    'TOGGLE_SHOW_NOTE_SHARE_LAYER_SUCCESS' = 'TOGGLE_SHOW_NOTE_SHARE_LAYER_SUCCESS',

    // 时间线数据
    'GET_TIMELINE_STAT_LIST' = 'GET_TIMELINE_STAT_LIST',
    'GET_TIMELINE_STAT_LIST_START' = 'GET_TIMELINE_STAT_LIST_START',
    'GET_TIMELINE_STAT_LIST_SUCCESS' = 'GET_TIMELINE_STAT_LIST_SUCCESS',
    'GET_TIMELINE_STAT_LIST_FAIL' = 'GET_TIMELINE_STAT_LIST_FAIL',

    // 更新用户 5 星评价数据
    'UPDATE_USER_STAR' = 'UPDATE_USER_STAR',
    'UPDATE_USER_STAR_START' = 'UPDATE_USER_STAR_START',
    'UPDATE_USER_STAR_SUCCESS' = 'UPDATE_USER_STAR_SUCCESS',
    'UPDATE_USER_STAR_FAIL' = 'UPDATE_USER_STAR_FAIL'
}

export enum EClassActionType {
    // 班级动态
    CLASS_GET_FEED_LIST = 'classGetFeedList',
    CLASS_GET_FEED_LIST_START = 'classGetFeedListStart',
    CLASS_GET_FEED_LIST_FAIL = 'classGetFeedListFail',
    CLASS_GET_FEED_LIST_SUCCESS = 'classGetFeedListSuccess',

    // 班级动态刷新
    CLASS_REFRESH_FEED_LIST = 'classRefreshFeedList',
    CLASS_REFRESH_FEED_LIST_START = 'classRefreshFeedListStart',
    CLASS_REFRESH_FEED_LIST_FAIL = 'classRefreshFeedListFail',
    CLASS_REFRESH_FEED_LIST_SUCCESS = 'classRefreshFeedListSuccess',

    // 发布
    CLASS_SAVE_NOTICE = 'classSaveNotice',
    CLASS_SAVE_NOTICE_START = 'classSaveNoticeStart',
    CLASS_SAVE_NOTICE_FAIL = 'classSaveNoticeFail',
    CLASS_SAVE_NOTICE_SUCCESS = 'classSaveNoticeSuccess',

    // 删除notice
    CLASS_DELETE_NOTICE = 'classDeleteNotice',
    CLASS_DELETE_NOTICE_START = 'classDeleteNoticeStart',
    CLASS_DELETE_NOTICE_FAIL = 'classDeleteNoticeFail',
    CLASS_DELETE_NOTICE_SUCCESS = 'classDeleteNoticeSuccess',

    // 置顶或取消置顶
    CLASS_SET_TOP_FEED = 'classSetTopFeed',
    CLASS_SET_TOP_FEED_START = 'classSetTopFeedStart',
    CLASS_SET_TOP_FEED_FAIL = 'classSetTopFeedFail',
    CLASS_SET_TOP_FEED_SUCCESS = 'classSetTopFeedSuccess',

    // 撤回任务
    CLASS_REVOKE_TASK = 'classRevokeTask',
    CLASS_REVOKE_TASK_START = 'classRevokeTaskStart',
    CLASS_REVOKE_TASK_FAIL = 'classRevokeTaskFail',
    CLASS_REVOKE_TASK_SUCCESS = 'classRevokeTaskSuccess',

    // 排行榜
    CLASS_RANKINGS_LIST = 'classRankingsList',
    CLASS_RANKINGS_LIST_START = 'classRankingsListStart',
    CLASS_RANKINGS_LIST_FAIL = 'classRankingsListFail',
    CLASS_RANKINGS_LIST_SUCCESS = 'classRankingsListSuccess',

    // 排行榜 今日
    CLASS_RANKINGS_LIST_TODAY = 'classRankingsListToday',
    CLASS_RANKINGS_LIST_TODAY_START = 'classRankingsListTodayStart',
    CLASS_RANKINGS_LIST_TODAY_FAIL = 'classRankingsListTodayFail',
    CLASS_RANKINGS_LIST_TODAY_SUCCESS = 'classRankingsListTodaySuccess',

    // 排行榜 昨日
    CLASS_RANKINGS_LIST_YESTERDAY = 'classRankingsListYesterday',
    CLASS_RANKINGS_LIST_YESTERDAY_START = 'classRankingsListYesterdayStart',
    CLASS_RANKINGS_LIST_YESTERDAY_FAIL = 'classRankingsListYesterdayFail',
    CLASS_RANKINGS_LIST_YESTERDAY_SUCCESS = 'classRankingsListYesterdaySuccess',

    // 排行榜 最近7天
    CLASS_RANKINGS_LIST_LAST_7 = 'classRankingsListLast7',
    CLASS_RANKINGS_LIST_LAST_7_START = 'classRankingsListLast7Start',
    CLASS_RANKINGS_LIST_LAST_7_FAIL = 'classRankingsListLast7Fail',
    CLASS_RANKINGS_LIST_LAST_7_SUCCESS = 'classRankingsListLast7Success',

    // 排行榜 最近30天
    CLASS_RANKINGS_LIST_LAST_30 = 'classRankingsListLast30',
    CLASS_RANKINGS_LIST_LAST_30_START = 'classRankingsListLast30Start',
    CLASS_RANKINGS_LIST_LAST_30_FAIL = 'classRankingsListLast30Fail',
    CLASS_RANKINGS_LIST_LAST_30_SUCCESS = 'classRankingsListLast30Success',

    // 排行榜 全部
    CLASS_RANKINGS_LIST_ALL = 'classRankingsListAll',
    CLASS_RANKINGS_LIST_ALL_START = 'classRankingsListAllStart',
    CLASS_RANKINGS_LIST_ALL_FAIL = 'classRankingsListAllFail',
    CLASS_RANKINGS_LIST_ALL_SUCCESS = 'classRankingsListAllSuccess',

    // 班级管理者的学习任务
    CLASS_ADMIN_TASK_LIST = 'classAdminTaskList',
    CLASS_ADMIN_TASK_LIST_START = 'classAdminTaskListStart',
    CLASS_ADMIN_TASK_LIST_FAIL = 'classAdminTaskListFail',
    CLASS_ADMIN_TASK_LIST_SUCCESS = 'classAdminTaskListSuccess',

    // 班级学员的学习任务
    CLASS_LEARNER_TASK_LIST = 'classLearnerTaskList',
    CLASS_LEARNER_TASK_LIST_START = 'classLearnerTaskListStart',
    CLASS_LEARNER_TASK_LIST_FAIL = 'classLearnerTaskListFail',
    CLASS_LEARNER_TASK_LIST_SUCCESS = 'classLearnerTaskListSuccess',

    CLASS_TASK_COMPLETION_LIST = 'classTaskComletion',
    CLASS_TASK_COMPLETION_LIST_START = 'classTaskComletionStart',
    CLASS_TASK_COMPLETION_LIST_FAIL = 'classTaskComletionFail',
    CLASS_TASK_COMPLETION_LIST_SUCCESS = 'classTaskComletionSuccess',

    // 获取完成学员
    CLASS_TASK_COMPLETED_LIST = 'classTaskComleted',
    CLASS_TASK_COMPLETED_LIST_START = 'classTaskComletedStart',
    CLASS_TASK_COMPLETED_LIST_FAIL = 'classTaskComletedFail',
    CLASS_TASK_COMPLETED_LIST_SUCCESS = 'classTaskComletedSuccess',

    // 获取未完成学员
    CLASS_TASK_INCOMPLETE_LIST = 'classTaskIncomlete',
    CLASS_TASK_INCOMPLETE_LIST_START = 'classTaskIncomleteStart',
    CLASS_TASK_INCOMPLETE_LIST_FAIL = 'classTaskIncomleteFail',
    CLASS_TASK_INCOMPLETE_LIST_SUCCESS = 'classTaskIncomleteSuccess',

    // 获取分享卡风格列表
    THEME_LIST_FETCH = 'THEME_LIST_FETCH',
    THEME_LIST_FETCH_SUCCESS = 'THEME_LIST_FETCH_SUCCESS',
    // 分享埋点
    RECORD_SHARE_THEME = 'RECORD_SHARE_THEME'
}

export enum ImgUploadSourceType {
    ALBUM = 'album',
    CAMERA = 'camera'
}

export enum DEPARTMENT_ACCESS {
    ADMIN = 0, // 无限制
    DEPARTMENT_HEAD = 1, // 部门负责人负责的部门
    DEPARTMENT_MANAGE = 2, // 子管理员管理的部门
    DEPARTMENT_HEAD_MANAGE = 3, // 负责的部门 + 管理的部门
}

// 学习任务自动分配的方式
export enum ELearningTaskAutoAssignWay {
    SAME_TTL = 0,
    SAME_END_TIME = 1,
}
// 学习任务完成状态
export enum ELearningTaskCompleteStatus {
    INCOMPLETE = 0,
    COMPLETED = 1,
}
// 学习任务自动分配开关状态
export enum ELearningTaskAutoAssignStatus {
    NO = 0,
    YES = 1,
}
